import React, { useEffect, useRef } from "react"

// The two kinds of checkbox in the Role Simulator (RolePicker): a role, submitted as a Rails
// checkbox, and a select-all over some roles, which is never submitted.

export type Role = { name: string; id: string; label: string; checked: boolean }

export type Checked = Record<string, boolean>

export type OnSet = (names: string[], value: boolean) => void

export const countChecked = (names: string[], checked: Checked) =>
  names.filter((name) => checked[name]).length

/** A select-all box showing none, some (indeterminate) or all of `names` ticked. */
export const SelectAll = ({
  id,
  label,
  names,
  checked,
  onSet,
}: {
  id: string
  label: string
  names: string[]
  checked: Checked
  onSet: OnSet
}) => {
  const ref = useRef<HTMLInputElement>(null)
  const count = countChecked(names, checked)
  const all = names.length > 0 && count === names.length
  const some = count > 0 && !all

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = some
    }
  }, [some])

  return (
    <input
      ref={ref}
      id={id}
      type="checkbox"
      className="form-check-input mt-0"
      aria-label={label}
      checked={all}
      onChange={(event) => onSet(names, event.target.checked)}
    />
  )
}

export const RoleCheckbox = ({
  role,
  checked,
  onSet,
}: {
  role: Role
  checked: Checked
  onSet: OnSet
}) => (
  <div className="form-check">
    <input type="hidden" name={role.name} value="0" autoComplete="off" />
    <input
      id={role.id}
      type="checkbox"
      className="form-check-input"
      name={role.name}
      value="1"
      checked={Boolean(checked[role.name])}
      onChange={(event) => onSet([role.name], event.target.checked)}
    />
    <label className="form-check-label" htmlFor={role.id}>
      {role.label}
    </label>
  </div>
)
